import React, { useState, useEffect } from "react";
import config from "../../config/config.json";
import { get } from "../../utils/HttpRequest";
import { Card, Row, Col, Container } from "react-bootstrap";
import { Dialog } from "primereact/dialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAward } from "@fortawesome/free-solid-svg-icons";
import { Button } from "primereact/button";

const DashboardSimulator = (props) => {
  const [dashboardData, setDashboardData] = useState([]);
  const [userEmail, setUserEmail] = useState("");
  const [selectedLessonIdToShow, setSelectedLessonIdToShow] = useState(null);

  useEffect(() => {
    if (props.userData && props.userData.group) {
      if(props.userData.givenName!="MyFirstName"){
        setUserEmail("for "+props.userData.givenName);
      } else {
        setUserEmail("");
      }
      var url = `${config.api.url}getParticularUserboard?user=${props.userData.group}`;
      let dashUrl = url;
      if (selectedLessonIdToShow != null) {
        dashUrl = `${url}&lessonid=${selectedLessonIdToShow}`;
      }
      get(dashUrl).then((response) => {
        setDashboardData(response.data.dashboard);
      });
    }
  }, [selectedLessonIdToShow, props.userData]);

  const handleCardClick = (lessonRow) => {
    if (lessonRow.lessontype === "nestedcard") {
      setSelectedLessonIdToShow(lessonRow.id);
    }
  };

  const handleReturnBtnClick = () => {
    setSelectedLessonIdToShow(null);
  };

  return (
    <div>
      <Dialog
        // header={`Dashboard preview for ${userEmail}`}
        header={
          <div>
            <Row>
              <Col sm={9} md={9} lg={8}>
                <span className="">Dashboard preview {userEmail} </span>
              </Col>
              <Col sm={3} md={3} lg={4}>
                <Button
                  label="Return to Dashboard"
                  onClick={() => {
                    handleReturnBtnClick();
                  }}
                  style={{
                    background: "black",
                    display: selectedLessonIdToShow != null ? "block" : "none",
                  }}
                />
              </Col>
            </Row>
          </div>
        }
        visible={props.dashboardSimulatorDialogVisible}
        position="top"
        style={{ width: "50vw", height: "80vh" }}
        onHide={() => {
          props.dashboardSimulatorDialogOnClose(false);
          props.setUserDataForDashboardSimulator(null);
          setUserEmail(null);
        }}
        dismissableMask={true }
        draggable={false}
        resizable={false}
      >
        <Container fluid>
          <Row style={{ width: "100%" }}>
            {dashboardData.map((lesson, k) => (
              <Col key={k} xs={12} md={4} lg={3} className="smi-card-outer">
                <Card
                  className={`smi-card card-hover-shadow
                     ${lesson.lessoncardtype ? lesson.lessoncardtype : ""} 
                     ${lesson.lessoncardtype === "pinkCard" ? "card-border" : ""} 
                     ${lesson.lessoncardtype === "blackCard" ? "card-border" : ""} 
                     ${lesson.lessoncardtype === "greenCard" ? "card-border" : ""} 
                     ${lesson.lessoncardtype === "lightblueCard" ? "card-border" : ""} 
                     ${lesson.lessoncardtype === "blueCard" ? "card-border" : ""}`}
                  onClick={() => {
                    lesson.lessontype === "nestedcard" && handleCardClick(lesson);
                  }}
                >
                  <Card.Header className="p-1">
                    <div className=" flex flex-row ">
                      <h6 className="  col-9  truncateText text-left float-left">
                        {lesson.name}
                      </h6>
                      {lesson.status === "completed" ? (
                        <FontAwesomeIcon
                          icon={faAward}
                          color="green"
                          className="col-2 downloadCertificate  c-smi-green smi-btn text-right float-right mt-1"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Card.Header>
                  <Card.Body
                    className="smi-card-body onclickLesson"
                    data-id={lesson.id}
                  >
                    {/* Header Section */}
                    {lesson.lessoncardheader && (
                      <div
                        className={` ${lesson.lessoncardtype === "whiteCard" ? "cardOptionalText1" : ""} 
                        ${lesson.lessoncardtype === "blueCard" ? "blueHeaderBg" : ""} 
                        ${lesson.lessoncardtype === "greenCard" ? "greenHeaderBg" : ""} 
                        ${lesson.lessoncardtype === "pinkCard" ? "pinkHeaderBg" : ""} 
                        ${lesson.lessoncardtype === "blackCard" ? "blackHeaderBg" : ""} 
                        ${lesson.lessoncardtype === "lightblueCard" ? "lightblueHeaderBg" : ""} 
                        ${lesson.lessoncardtype === "yellowCard" ? "yellowHeaderBg" : ""} 
                        ${lesson.lessoncardtype === "lightgrayCard" ? "lightgrayHeaderCard" : ""} py-1 px-2`}
                      >
                        <h6 className="font-weight-300 truncateText">
                          {lesson.lessoncardheader}
                        </h6>
                      </div>
                    )}

                    {/* Image Section */}
                      <div>
                        <a className="img-link h-100 d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          <div>
                            <Card.Img
                              className={`img-fluid d-flex align-items-center justify-content-center cardImg  ${
                                lesson.status === "completed"
                                  ? "completeLesson"
                                  : ""
                              }`}
                              loading="lazy"
                              src={`${config.content.url}${lesson.id}/${lesson.id}.png`}
                              alt={lesson.id}
                            />
                          </div>
                        </a>
                        <a className="img-link h-100 d-block d-sm-none">
                          {" "}
                          {/* Mobile view tag */}
                          <div>
                            <Card.Img
                              className={`img-fluid d-flex align-items-center justify-content-center cardImg  ${
                                lesson.status === "completed"
                                  ? "completeLesson"
                                  : ""
                              }`}
                              loading="lazy"
                              src={`${config.content.url}${lesson.id}/${lesson.id}.png`}
                              alt={lesson.id}
                            />
                          </div>
                        </a>
                      </div>
                    {lesson.lessoncarddescription ? (
                      <div className="py-4 text-sm">
                        <span className="px-2">{lesson.lessoncarddescription}</span> 
                        <div className="col-12 text-xs justify-content-start text-left ">
                          COMPLETED
                        </div>
                      </div>
                    ) : lesson.status === "completed" ? (
                      lesson.lessontype === "assessment" ? (
                        lesson.result === "Pass" ? (
                          <div
                            className={`col-12 text-left text-xs ${lesson.lessoncardfooter
                                ? "lessonStatus1"
                                : "lessonStatus"
                              } `}
                          >
                            COMPLETED
                          </div>
                        ) : (
                          <div
                            className={`col-12 ${lesson.lessoncardfooter
                                ? "retakeLesson1"
                                : "retakeLesson"
                              }`}
                          >
                            RETAKE
                          </div>
                        )
                      ) : lesson.result === "NA" ? (
                        <div
                          className={`col-12 text-left text-xs ${lesson.lessoncardfooter
                              ? "lessonStatus1"
                              : "lessonStatus"
                            } `}
                        >
                          COMPLETED
                        </div>
                      ) : (
                        <div
                          className={`col-12 ${lesson.lessoncardfooter
                              ? "retakeLesson1"
                              : "retakeLesson"
                            }`}
                        >
                          RETAKE
                        </div>
                      )
                    )  : (
                      ""
                    )}

                    {/* Footer Section */}
                    {lesson.lessoncardfooter && (
                      <div
                        className={`${lesson.lessoncardtype === "whiteCard" ? "cardFooterOptional1" : ""} 
                        ${lesson.lessoncardtype === "blueCard" ? "blueFooterBg" : ""} 
                        ${lesson.lessoncardtype === "greenCard" ? "greenFooterBg" : ""} 
                        ${lesson.lessoncardtype === "pinkCard" ? "pinkFooterBg" : ""} 
                        ${lesson.lessoncardtype === "blackCard" ? "blackFooterBg" : ""} 
                        ${lesson.lessoncardtype === "lightblueCard" ? "lightblueFooterBg" : ""} 
                        ${lesson.lessoncardtype === "yellowCard" ? "yellowFooterBg" : ""} 
                        ${lesson.lessoncardtype === "lightgrayCard" ? "lightgrayFooterBg" : ""} footer-border py-1 px-2`}
                      >
                        <h6 className="font-weight-100 truncateText">
                          {lesson.lessoncardfooter}
                        </h6>
                      </div>
                    )}
                  </Card.Body>

                  <div className="smi-card-footer">
                    <div className="smi-lessoncard-header">
                      <div className="task-title mr-auto w-100">
                        <div className="row">
                          <div className="small p-0 text-left float-left">
                            {" "}
                            {lesson.lessonRequired === "true"
                              ? "REQUIRED"
                              : "OPTIONAL"}
                          </div>
                        </div>
                      </div>
                      {/* <Dropdown>
                                                <Dropdown.Toggle as={CustomToggle} >
                                                    <button className="btn btn-icon btn-light" id="dropdown-basic">
                                                        <FontAwesomeIcon icon={faEllipsisV} />
                                                    </button>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className="dropdown-menu-right">
                                                    <Dropdown.Item href="#">Added: {lesson.lessonAdded}</Dropdown.Item>
                                                    <Dropdown.Item href="#">Duration: {lesson.lessonDuration}</Dropdown.Item>
                                                    <Dropdown.Item href="#">Version: {lesson.version}</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown> */}
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </Dialog>
    </div>
  );
};
export default DashboardSimulator;
